const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNinjaOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(1.2, 1.2) scale(0.9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.960784%,21.960784%,33.725491%)",
      fillOpacity: 1
    },
    d: "M 1.800781 -0.0390625 L 22.050781 -0.0390625 C 23.082031 -0.0390625 23.925781 0.804688 23.925781 1.835938 L 23.925781 22.085938 C 23.925781 23.117188 23.082031 23.960938 22.050781 23.960938 L 1.800781 23.960938 C 0.769531 23.960938 -0.0742188 23.117188 -0.0742188 22.085938 L -0.0742188 1.835938 C -0.0742188 0.804688 0.769531 -0.0390625 1.800781 -0.0390625 Z M 1.800781 -0.0390625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(1.568628%,100%,53.333336%)",
      fillOpacity: 1
    },
    d: "M 16.164062 7.179688 C 15.355469 6.355469 14.289062 5.945312 12.957031 5.945312 C 11.625 5.945312 11.570312 6.074219 10.949219 6.320312 C 10.351562 6.582031 9.824219 6.9375 9.429688 7.40625 L 9.429688 5.738281 L 6.46875 7.125 L 6.46875 17.101562 L 9.5625 17.101562 L 9.5625 11.71875 C 9.5625 10.726562 9.789062 9.992188 10.257812 9.488281 C 10.726562 8.980469 11.34375 8.738281 12.113281 8.738281 C 12.882812 8.738281 13.351562 8.960938 13.726562 9.394531 C 14.101562 9.824219 14.289062 10.480469 14.289062 11.363281 L 14.289062 17.117188 L 17.382812 17.117188 L 17.382812 11.101562 C 17.382812 9.488281 16.96875 8.042969 16.164062 7.21875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinjaOne);
export default __webpack_public_path__ + "static/media/NinjaOne.8815f0a1e1a0f2cb241b36a9cbef79d3.svg";
export { ForwardRef as ReactComponent };